import React from "react";
import Group from "../../../../asesst/Group.svg";

const InspectorData = ({
  totalInspectors,
  activeInspectors,
  inactiveInspectors,
}) => {
  return (
    <div className="bg-white p-6 rounded-xl border border-slate-200 shadow-sm flex flex-col space-y-6">
      <h2 className="text-xl sm:text-2xl font-semibold text-slate-800">
        Inspector Data
      </h2>
      <div className="flex justify-between items-start lg:items-center">
        <div className="flex items-start lg:items-center space-x-6">
          <img src={Group} alt="Inspector" className="w-20 h-20" />
          <div>
            <p className="text-3xl sm:text-4xl font-semibold text-slate-800">
              {totalInspectors}
            </p>
            <p className="text-slate-600 text-base font-medium">
              Total Inspector
            </p>
          </div>
        </div>

        <div className="border-l border-slate-200 h-20 lg:h-24 mx-6"></div>

        <div className="flex flex-col space-y-6 lg:space-y-0 lg:flex-col lg:space-y-4 text-center">
          <div>
            <p className="text-3xl sm:text-4xl font-semibold text-slate-800">
              {activeInspectors}
            </p>
            <p className="text-emerald-600 text-base font-medium">
              Active Inspector
            </p>
          </div>
          <div>
            <p className="text-3xl sm:text-4xl font-semibold text-slate-800">
              {inactiveInspectors}
            </p>
            <p className="text-rose-600 text-base font-medium">
              Inactive Inspector
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InspectorData;
